import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #916ee8;
  width: 21px;
  height: 21px;
`

export const PencilIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={className}>
      <path d="M4.5 19.5H5.6L17.4 7.72502L16.3 6.62502L4.5 18.4V19.5ZM3 21V17.8L17.375 3.45002C17.5083 3.31669 17.6667 3.21252 17.85 3.13752C18.0333 3.06252 18.225 3.02502 18.425 3.02502C18.6083 3.02502 18.7917 3.06252 18.975 3.13752C19.1583 3.21252 19.325 3.31669 19.475 3.45002L20.575 4.55002C20.725 4.70002 20.8333 4.86669 20.9 5.05002C20.9667 5.23336 21 5.41669 21 5.60002C21 5.78336 20.9625 5.97086 20.8875 6.16252C20.8125 6.35419 20.7083 6.51669 20.575 6.65002L6.2 21H3ZM16.85 7.17502L16.3 6.62502L17.4 7.72502L16.85 7.17502Z" />
    </Svg>
  )
}
